// extracted by mini-css-extract-plugin
module.exports = {"choiceButton":"choiceButton--79f89","scrollY":"scrollY--9ef55"};